// SegmentCell — the `<td>` that says which segment a row was ranked in.
//
// It is the one part of the change that shows rather than tells: five rows with
// five different room ids are the fact that those five players never competed
// with each other. Shared between the Overview's Top 5 and the Cycles table for
// the same reason SegmentNote is.

import type { SegmentKind } from "./segments";
import type { Entry } from "./types";
import styles from "./SegmentCell.module.css";

/** Both tables abbreviate ids the same way the cycle id is abbreviated. */
function shortId(id: string | undefined, n = 8): string {
  if (!id) return "—";
  return id.replace(/-/g, "").slice(0, n);
}

export function SegmentCell({
  entry,
  kind,
}: {
  entry: Pick<Entry, "tier_key" | "bucket_id">;
  kind: SegmentKind;
}) {
  // Rooms off: the league IS the segment, and there is no room id to print.
  if (kind === "tier") {
    return (
      <td className={styles.segCell}>
        {entry.tier_key ? (
          <span className={styles.badge}>{entry.tier_key}</span>
        ) : (
          "—"
        )}
      </td>
    );
  }
  return (
    <td className={styles.segCell}>
      {kind === "tier_rooms" && entry.tier_key && (
        <span className={styles.badge}>{entry.tier_key}</span>
      )}
      {shortId(entry.bucket_id)}
    </td>
  );
}
